import Component from './Avatar.vue';

export default {
  install(Vue) {
    Vue.component('BkfAvatar', Component);
  },
};
